export default __webpack_public_path__ + "static/its_not_you-24b4383627bf0beb3a11843d1c25665b.png";